import { render, staticRenderFns } from "./Bonos.vue?vue&type=template&id=f1ae1cae&scoped=true&"
import script from "./Bonos.vue?vue&type=script&lang=js&"
export * from "./Bonos.vue?vue&type=script&lang=js&"
import style0 from "./Bonos.vue?vue&type=style&index=0&id=f1ae1cae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1ae1cae",
  null
  
)

export default component.exports